export default __webpack_public_path__ + "static/media/group-option-moustache-selected.aeb3ecd6.svg";